// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"0c97a569","228":"307bb143","495":"51ceda24","571":"5ba61446"}[chunkId] + ".css";
};